import { IVirtualTrip, TransferTaskType } from "../../../common/plannerTypes";
import { TransferEstimateTaskType } from "../../../common/types";

export enum LineType {
    none = 0,
    quater = 1,
    hour = 3
}

export enum ClosePeriodType {
    start = 1,
    end = 2
}

export enum ServicedBy {
    SMA = 1,
    Customer = 2
}

export enum TimelineCommandType{
    moveTrip = 1,
    addToTrip = 2,
    removeFromTrip = 3,
    applyTransferOrderChanges = 4,
    overrideTrip = 5,
}

export interface IPlannerMinute {
    id: number,
    date: Date,
    trip: IVirtualTrip | null,
    tripPlannerId: string,
    isDnD: boolean
    isPassed: boolean,
    sharingRole :string | null,
    sharedPlannerId :string | null,
    timezone:string|null,
    tripStyle: {
        isOverlapped: boolean,
        isOverlappedStart: boolean,
        isOverlappedEnd: boolean,
        isTripBlockStart: boolean,
        isTripBlockEnd: boolean,
        isTripStart: boolean,
        isTripEnd: boolean,
        isConflictingTrip: boolean,
        isInsivible: boolean, // is a trip is dragged 
    }
}
export interface Iuser {
        ApplicationPermissionId :string|null,
        Name :string|null,
        IsAdmin :string|null,
        CategoryId :string|null,
        RequireScope :string|null,
        IsInternal :string|null,
        DisplayName :string|null,
        Description :string|null,
        CategoryName :string|null,
        Order :string|null,
        Role :string|null,
        SubName :string|null,
}
export interface IPlannerLabel {
    hourStr: string,
    hour: Date   
}

export interface ITripPlanner {
    tripPlannerId: string,
    locationId: string,
    noOfStretchers: number | null,
    noOfPatientSeats: number | null,
    maxPatientAcuity: string | null,
    noOfPickupDropoffs: number | null,
    isMutliloadAllowed: boolean | null,
    schedulingLeadTtime: number | null,
    sequence: number | null,

    open: boolean | null,
    plannerStartTime: number | null,
    plannerEndTime: number | null,
    plannerBreakStartTime: number | null,
    plannerBreakDuration: number | null,
    plannerMaxBreakDelay: number | null,
    sharingRole :string | null,
    sharedPlannerId :string | null,
    plannerName:string | null,
    plannerNamePlaceholder:string|null,
    timezone:string|null,
    servicedBy:string|null
}

export interface IDropResult {
    target?: string,
    plannerMinute?: IPlannerMinute,
    applyTimelineChanges?: any
    removeTripFromPlanner?: any
}

export interface ITripPlannerTransferResponse {
    tripPlannerId: string,
    transferId: string,
    scheduleDate: string,
    status: number | null,
    estimatedDurationInMunutes: number | null
}


export interface ITransferEstimate {
    transferId: string,
    type: TransferTaskType
} 

export interface ITripPlannerEstimateRequest {
    virtualTripId: string,
    scheduleDate: string,
    locationId: string,
    tripPlannerId: string | null,
    transferEstimates: ITransferEstimate[]
    transfers: string[]
    isTripMinOverrided : boolean
    overrideTripEstimateInMin : Number
}

export interface ITransferTaskEstimateVM {
    type: TransferEstimateTaskType,
    typeName: string,
    startTime: string,
    customerLocationtimezone: string,
    duration: number,
    completedTime: string,
}

export interface ITransferEstimateVM {
    transferId: string,
    transferStart: string,
    customerLocationtimezone: string,
    transferDuration: number,
    taskEstimates: ITransferTaskEstimateVM[]
}

export interface ITripPlannerEstimateResponse {
    virtualTripId: string,
    tripStartTime: string,
    tripEndTime: string,
    tripOverridedEndTime: string,
    isTripMinOverrided: boolean,
    tripDuration: number,
    transferEstimates: ITransferEstimateVM[]
}

export interface ITimelineCommand{
    type: TimelineCommandType,
    plannerMinute: IPlannerMinute | null,
    tripUpdates: IVirtualTrip | null,
    trasferIdForRemoving: string
}

export interface VirtualTripModel {
    virtualTripId: string,
    scheduledDate: string,
    locationId: string,
    tripPlannerId: string | null,
    estimatedDurationInMinutes: number
}

export interface TripPlannerTransferModel {
    transferId: string,
    tripPlannerId: string | null,
    status: number,
    scheduledDate: string | null,
    isTripMinOverrided : boolean
    overrideTripEstimateInMin : Number
    estimatedDurationInMinutes: number | null,
    virtualTripId: string| null,
    eta: string | null,
}

export interface ITripPlannerBatchRequest {
    virtualTrips: VirtualTripModel[],
    transfers: TripPlannerTransferModel[],
    selectedDay: string,
    selectedLocationId: string,
}

export interface IVirtualTripUpdate {
    resultTrip: IVirtualTrip,
    freedTripAfterRemoving: IVirtualTrip | null,
    ignoreResultTrip: boolean
}
